const PROD_DOCS = 'https://otw-docs-prod-m6uviqmkga-uc.a.run.app'

/** @deprecated Staging docs Cloud Run is retired. Portal links use production docs. */
export const STG_DOCS = 'https://otw-docs-stg-ky2zwlng5a-uc.a.run.app'

export function getDocsBaseUrl(): string {
  const override = process.env.VITE_DOCS_PUBLIC_URL?.trim()
  if (override) return override.replace(/\/$/, '')

  // Staging docs selection is deprecated.
  // const projectId = process.env.VITE_FIREBASE_PROJECT_ID
  // if (projectId === 'otw-production-91ffb') return PROD_DOCS
  // return STG_DOCS
  return PROD_DOCS
}

export function getDocsHomeUrl(): string {
  return getDocsBaseUrl()
}

export function getDocsChangelogUrl(): string {
  return `${getDocsBaseUrl()}/business/changelog`
}

export function getGitHubBoardUrl(): string {
  return 'https://github.com/orgs/the-freetech-company/projects/5'
}
